module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    staticClass: "editorClass"
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sfyyyqdl),
      expression: "sfyyyqdl"
    }],
    attrs: {
      "label": "活动推广：",
      "label-width": "120px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\r\n        每份现金金额："), _c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "请输入金额",
      "maxlength": "20"
    },
    model: {
      value: (_vm.mfxjje),
      callback: function($$v) {
        _vm.mfxjje = $$v
      },
      expression: "mfxjje"
    }
  }), _vm._v(" 元\r\n      ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\r\n        奖励份数："), _c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "请输入整数",
      "maxlength": "20"
    },
    model: {
      value: (_vm.jlfe),
      callback: function($$v) {
        _vm.jlfe = $$v
      },
      expression: "jlfe"
    }
  }), _vm._v(" 份\r\n      ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\r\n        需要充值金额： "), _c('b', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v(" " + _vm._s(_vm.xyczje.toFixed(2)) + " ")]), _vm._v(" 元\r\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tishi"
  }, [_c('p', [_vm._v("提示：1. 本红包用于奖励创客推广本活动；")]), _vm._v(" "), _c('p', [_vm._v("2. 本功能需要进行现金充值，活动结束后未领取的金额，请到活动列表中的\"推广记录\"功能页面中申请退款；退款将退回原微信支付账户；")]), _vm._v(" "), _c('p', [_vm._v("3. 充值金额含6‰的手续费；活动配置完成后在开启活动时根据提示进行充值操作。 ")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创客分享奖现金：",
      "label-width": "120px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit != 2),
      expression: "isEdit != 2"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.configuration(2)
      }
    }
  }, [_vm._v("配置")]), _vm._v(" "), (_vm.recharge.totalcount != 0) ? [_c('span', {
    staticClass: "threePrice"
  }, [_vm._v("单份奖励：" + _vm._s(_vm.rewardTwo) + "元")]), _vm._v(" "), _c('span', {
    staticClass: "threePrice"
  }, [_vm._v("奖励份数：" + _vm._s(_vm.recharge.totalcount) + "份")]), _vm._v(" "), _c('span', {
    staticClass: "threePrice"
  }, [_vm._v("需充值金额：" + _vm._s(Math.ceil(_vm.recharge.totalprice * 100) / 100) + " 元（微信收取" + _vm._s(_vm.wxrate * 1000) + "‰手续费）")])] : [_c('span', {
    staticClass: "threePrice"
  }, [_vm._v("无配置")])], _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit != 2 && _vm.recharge.totalcount != 0),
      expression: "isEdit != 2 && recharge.totalcount !=0"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.chongzhiPz()
      }
    }
  }, [_vm._v("重置")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动说明：",
      "label-width": "120px"
    }
  }, [_c('wjEditor', {
    attrs: {
      "desc": _vm.content1
    },
    on: {
      "change": _vm.contentChangeOne
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialogFooter"
  }, [_c('el-button', {
    on: {
      "click": _vm.toPrevStep
    }
  }, [_vm._v("上一步")]), _vm._v(" "), (!(_vm.isEdit == 2 || _vm.isEdit == 3)) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loadingBut
    },
    on: {
      "click": _vm.saveAllForm
    }
  }, [_vm._v(_vm._s(_vm.loadingButText))]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "创客分享奖现金",
      "visible": _vm.prizeCash,
      "center": true,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.prizeCash = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-right": "30px",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "单份奖励："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.rewardTwo) + "元")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "奖励份数："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入奖励份数",
      "maxlength": "7"
    },
    model: {
      value: (_vm.recharge.totalcount),
      callback: function($$v) {
        _vm.$set(_vm.recharge, "totalcount", $$v)
      },
      expression: "recharge.totalcount"
    }
  })], 1)], 1), _vm._v(" "), _c('p', [_vm._v("充值金额："), _c('span', [_vm._v("　" + _vm._s(Math.ceil(_vm.recharge.totalprice * 100) / 100) + " 元（含微信收取" + _vm._s(_vm.wxrate * 1000) + "‰手续费）")])]), _vm._v(" "), _c('p', [_vm._v("分享规则：　"), _c('el-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.fxdpyq),
      callback: function($$v) {
        _vm.fxdpyq = $$v
      },
      expression: "fxdpyq"
    }
  }, [_vm._v("分享到朋友圈")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "分享文案："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入分享文案内容",
      "maxlength": "100",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.recharge.remark),
      callback: function($$v) {
        _vm.$set(_vm.recharge, "remark", $$v)
      },
      expression: "recharge.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "分享要求："
    }
  }, [_c('div', {
    staticClass: "fxyqClass"
  }, _vm._l((_vm.tasktyps.descriptions), function(item) {
    return _c('p', {
      key: item
    }, [_vm._v(_vm._s(item.sort) + "." + _vm._s(item.taskdesc) + ";")])
  }), 0)]), _vm._v(" "), _c('b', {
    staticStyle: {
      "display": "block",
      "margin-bottom": "10px"
    }
  }, [_vm._v("付费推广目的：")]), _vm._v(" "), _c('ul', [_vm._l((_vm.ckfxjxj), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "line-height": "32px"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("4.示例视频")]), _vm._v(" "), _c('ul', {
    staticClass: "videoandpic"
  }, _vm._l((_vm.tasktyps.examples), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.handleplay(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.baseOssUrl + item.videoimg
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.mediatype == 2),
        expression: "item.mediatype == 2"
      }],
      staticClass: "el-icon-video-play mengceng"
    })])
  }), 0)], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.prizeCash = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.handleJxj()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.largeImage,
      "title": "图片查看"
    },
    on: {
      "update:visible": function($event) {
        _vm.largeImage = $event
      },
      "closed": _vm.clearImg
    }
  }, [_c('div', {
    staticClass: "imgDialog"
  }, [_c('img', {
    attrs: {
      "src": _vm.showImageUrl
    }
  })])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.videoVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-974bac3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/addOrEditActive/activityDescription.vue
// module id = 1728
// module chunks = 3